module.exports = __webpack_public_path__ + "static/media/backhoe_pink.52392c10.svg";